import { render, staticRenderFns } from "./Mailer.vue?vue&type=template&id=619ca426&"
import script from "./Mailer.vue?vue&type=script&lang=js&"
export * from "./Mailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports